var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"name":`${!!_vm.type ? `${_vm.type}` : ``}state`,"options":!!_vm.dc ? _vm.states_dc[this.l] : _vm.states[this.l],"type":"select","label":`${_vm.$t('state')}`,"tooltip":!!_vm.tip ? _vm.$t(_vm.tip) : _vm.$t('state_tooltip')}})
}
var staticRenderFns = []

export { render, staticRenderFns }